module.exports = __webpack_public_path__ + "img/s1-3-ja.e27dc239.jpg";